/**
 * Ввод номера партии — общий для скан-экранов.
 *
 * ⚠️ Блок был написан дважды, слово в слово, в проверке заказов и в проверке
 * перемещений. Правка в одном месте и забытая во втором — самый частый способ
 * развести два экрана: именно так у них разъехался выбор характеристики, и
 * ровно там сидел баг, из-за которого в позицию уезжала строка «none».
 *
 * ⚠️ Здесь же живёт «Принять без партии» — единственный контрол шторки,
 * который кладёт в документ 1С ПУСТУЮ ссылку осознанно. Его поведение должно
 * быть одинаковым везде: там, где партия не найдена, портал не подставляет
 * чужую, а спрашивает человека.
 */
import { Loader2 } from "lucide-react";
import React from "react";

import { Button } from "@/components/ui/button";

export function PartiaAsk({
  value,
  onChange,
  hasPicked,
  picked,
  onReset,
  onLookup,
  busy,
  withoutPartia,
  onWithoutPartia,
}: {
  /** Что набрано в поле. */
  value: string;
  onChange: (v: string) => void;
  /** Партия найдена — тогда поле сменяется галочкой. */
  hasPicked: boolean;
  /** Имя найденной партии для показа. */
  picked: string;
  onReset: () => void;
  onLookup: (name: string) => void;
  busy: boolean;
  withoutPartia: boolean;
  onWithoutPartia: (v: boolean) => void;
}): React.ReactElement {
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-2">
      <div className="mb-1.5 text-[12px] font-semibold text-amber-700">Партия:</div>
      {/* ⚠️ Условие — по НАЙДЕННОСТИ, а не по имени. Вынося блок общим, я
          завязал его на имя партии, и у партии с пустым именем шторка снова
          показывала бы поле ввода, хотя ссылка уже есть: оператор набрал бы
          другой номер и молча заменил найденную партию. */}
      {hasPicked && !withoutPartia ? (
        <div className="flex items-center justify-between text-[13px]">
          <span className="text-emerald-700">✓ {picked || "—"}</span>
          <button
            type="button"
            className="text-[11px] text-slate-500 underline"
            onClick={onReset}
          >
            изменить
          </button>
        </div>
      ) : !withoutPartia ? (
        <div className="flex items-center gap-2">
          <input
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Номер партии"
            className="h-11 flex-1 rounded-lg border px-2 text-[14px]"
          />
          <Button
            type="button"
            className="h-11 w-24 bg-sky-700"
            disabled={!value.trim() || busy}
            onClick={() => onLookup(value.trim())}
          >
            {busy ? <Loader2 className="size-4 animate-spin" /> : "Найти"}
          </Button>
        </div>
      ) : null}
      <label className="mt-1.5 flex items-center gap-2 text-[13px]">
        <input
          type="checkbox"
          checked={withoutPartia}
          onChange={(e) => onWithoutPartia(e.target.checked)}
        />
        Принять без партии
      </label>
    </div>
  );
}
